// extracted by mini-css-extract-plugin
export default {"ZoomToolbar":"ZoomToolbarCanvas_ZoomToolbar__UEn0r","ZoomToolbar__Percentage":"ZoomToolbarCanvas_ZoomToolbar__Percentage__8Y29-"};